module.exports = __webpack_public_path__ + "img/plan_t3.d0fc21a8.webp";